/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EventCategories {
    Product_Creations = 110100,
    Product_MasterDataChanges = 110200,
    Product_Deletions = 110300,
    Product_Type = 110400,
    Product_Pictures = 110500,
    Product_AssetStore = 110600,
    Customer_Creations = 120100,
    Customer_MasterDataChanges = 120200,
    Customer_Deletions = 120300,
    Customer_ContactPersons = 120400,
    Customer_Projects = 120500,
    Customer_Contactperson = 120600,
    Employee_Creations = 140100,
    Employee_MasterDataChanges = 140200,
    Employee_Communication = 140300,
    Document_Type_Creations = 150100,
    Document_Type_MasterDataChanges = 150200,
    Document_Type_Deletions = 150300,
    System_Settings_MasterDataChanges = 160100,
    Configurator_List_Creations = 170100,
    Configurator_List_MasterDataChanges = 170200,
    Configurator_List_Deletions = 170300,
    Configurator_List_Item_Creations = 180100,
    Configurator_List_Item_MasterDataChanges = 180200,
    Configurator_List_Item_Deletions = 180300,
    Configurator_Attribute_Creations = 190100,
    Configurator_Attribute_MasterDataChanges = 190200,
    Configurator_Attribute_Deletions = 190300,
    Configurator_Rule_Creations = 200100,
    Configurator_Rule_MasterDataChanges = 200200,
    Configurator_Rule_Deletions = 200300,
    SystemProductConfiguration_MasterDataChanges = 210200,
}
